import { CardActionsLayout } from '../../components/CardActionsLayout';
import { ChatButtonContainer } from '../ChatButtonContainer';
import { ShowPhoneButtonContainer } from '../ShowPhoneButton';

export function TabletCardActionsContainer() {
  return (
    <CardActionsLayout>
      <ShowPhoneButtonContainer />
      <ChatButtonContainer />
    </CardActionsLayout>
  );
}
